import {
  ADD_UPDATE_PROMOTIONAL_ROW_CURRENT_STATUS,
  SET_AEON_SEARCH_LIST,
  SET_BACK_OFFICE_ENROLLMENT_RANK,
  SET_BACK_OFFICE_ENROLLMENT_TYPE,
  SET_CART_ADDITIONAL_ATTRIBUTES_INCOMPLETE_IDS,
  SET_CART_PWP_ITEM_TEMP_LIST,
  SET_CART_PWP_VALIDATION_IDS,
  SET_EPP_MOTO_APPROVAL_RESPONSE_DATA,
  SET_EPP_MOTO_REJECTION_RESPONSE_DATA,
  SET_EPP_SEARCH_LIST,
  SET_ORDER_CANCELLATION_DATA,
  SET_ORDER_CANCELLATION_SEARCH_LIST,
  SET_ORDER_DATA,
  SET_PAYMENT_OPTIONS,
  SET_PRODUCT_EXCHANGE_DATA,
  SET_PRODUCT_EXCHANGE_SEARCH_LIST,
  SET_SALE_ELIGIBLE_ERROR,
  SET_SALES_ADDRESSES_DATA,
  SET_SALES_DATA,
  SET_SALES_EXCHANGE_DATA,
  SET_SALES_INVOICE_LIST_DATA,
  SET_SALES_LIST_DATA,
  SET_SALES_PRODUCTS_LIST_DATA,
  SET_TAX_INVOICE_LISTING,
  SET_SALE_ELIGIBLE_TRANSFER_SEARCH,
  SET_SALE_TRANSFER_DATA,
  UNSET_CART_ADDITIONAL_ATTRIBUTES_INCOMPLETE_IDS,
  UNSET_CART_PWP_ITEM_TEMP_LIST,
  UNSET_CART_PWP_VALIDATION_IDS,
  UNSET_ORDER_CANCELLATION_DATA,
  UNSET_ORDER_DATA,
  UNSET_PRODUCT_EXCHANGE_DATA,
  UNSET_PROMOTIONAL_ROW_CURRENT_STATUS,
  UNSET_SALES_ADDRESSES_DATA,
  UNSET_SALES_PRODUCTS_LIST_DATA,
  UNSET_SALE_TRANSFER_DATA,
  SET_SALE_SV_TRANSFER_BY_PRODUCT_ITEMS,
  SET_SV_TRANSFER_BY_PRODUCT_FORM_DATA,
  UNSET_SV_TRANSFER_BY_PRODUCT_DATA,
} from 'src/store/types'
import Vue from 'vue'
import Helpers from 'src/helpers'

export default {
  [SET_SALES_LIST_DATA](state, payload) {
    Vue.set(state.salesList, 'list', payload.list)
  },
  [SET_ORDER_CANCELLATION_SEARCH_LIST](state, payload) {
    Vue.set(state.salesCancellationList, 'list', payload.list)
  },
  [SET_ORDER_DATA](state, payload) {
    Object.keys(payload).forEach(function(key) {
      Vue.set(state.orderData, key, payload[key])
    })
  },
  [UNSET_ORDER_DATA](state, payload) {
    Object.keys(payload).forEach(function(key) {
      Vue.delete(state.orderData, key)
    })
  },
  [SET_ORDER_CANCELLATION_DATA](state, payload) {
    Object.keys(payload).forEach(function(key) {
      Vue.set(state.salesCancellationData, key, payload[key])
    })
  },
  [UNSET_ORDER_CANCELLATION_DATA](state, payload) {
    Object.keys(payload).forEach(function(key) {
      Vue.delete(state.salesCancellationData, key)
    })
  },
  [SET_PRODUCT_EXCHANGE_DATA](state, payload) {
    Object.keys(payload).forEach(function(key) {
      Vue.set(state.productExchangeData, key, payload[key])
    })
  },
  [UNSET_PRODUCT_EXCHANGE_DATA](state, payload) {
    Object.keys(payload).forEach(function(key) {
      Vue.delete(state.productExchangeData, key)
    })
  },
  [SET_SALES_PRODUCTS_LIST_DATA](state, payload = false) {
    if (!payload) {
      payload = {
        data: [],
        total: '0',
      }
    }
    Vue.set(state.salesProductSearchList, 'list', payload.data)
  },
  [SET_SALES_INVOICE_LIST_DATA](state, payload) {
    Vue.set(state.salesInvoiceSearchList, 'list', payload.list)
  },
  [SET_CART_PWP_VALIDATION_IDS](state, id) {
    state.cartPwpValidationIds.push(id)
  },
  [UNSET_CART_PWP_VALIDATION_IDS](state, index) {
    if (typeof index !== 'undefined') {
      state.cartPwpValidationIds.splice(index, 1)
    } else {
      state.cartPwpValidationIds.splice(0, state.cartPwpValidationIds.length)
    }
  },
  [SET_CART_PWP_ITEM_TEMP_LIST](state, payload) {
    state.cartPwpItemsTempList.push(payload)
  },
  [UNSET_CART_PWP_ITEM_TEMP_LIST](state, index) {
    if (typeof index !== 'undefined') {
      state.cartPwpItemsTempList.splice(index, 1)
    } else {
      state.cartPwpItemsTempList.splice(0, state.cartPwpItemsTempList.length)
    }
  },
  [SET_PAYMENT_OPTIONS](state, payload) {
    Vue.set(state.paymentOptions, 'list', payload.list)
  },
  [SET_SALES_DATA](state, payload) {
    let data = payload.data
    Vue.set(state.salesData, 'data', data)
  },
  [SET_SALES_ADDRESSES_DATA](state, payload) {
    state.salesAddresses = []
    payload.forEach(item => {
      state.salesAddresses.push(item)
    })
  },
  [UNSET_SALES_ADDRESSES_DATA](state) {
    state.salesAddresses.splice(0, state.salesAddresses.length)
  },
  [ADD_UPDATE_PROMOTIONAL_ROW_CURRENT_STATUS](state, payload) {
    let itemIndex = payload.index
    let data = payload.data
    if (itemIndex !== -1) {
      if (state.cartPromotionalRowCurrentStatus[itemIndex].valid !== data.valid) {
        state.cartPromotionalRowCurrentStatus[itemIndex].valid = data.valid
      }
    } else {
      state.cartPromotionalRowCurrentStatus.push(data)
    }
  },
  [UNSET_PROMOTIONAL_ROW_CURRENT_STATUS](state, payload) {
    if (typeof payload !== 'undefined') {
      let itemIndex = state.cartPromotionalRowCurrentStatus.findIndex(x => x.promoID === payload.promoID)
      state.cartPromotionalRowCurrentStatus.splice(itemIndex, 1)
    } else {
      state.cartPromotionalRowCurrentStatus.splice(0, state.cartPromotionalRowCurrentStatus.length)
    }
  },
  [SET_PRODUCT_EXCHANGE_SEARCH_LIST](state, payload) {
    Vue.set(state.productExchangeList, 'list', payload.list)
  },
  [SET_AEON_SEARCH_LIST](state, payload) {
    Vue.set(state.aeonPaymentList, 'list', payload.list)
  },
  [SET_EPP_SEARCH_LIST](state, payload) {
    Vue.set(state.eppPaymentList, 'list', payload.list)
  },
  [SET_SALES_EXCHANGE_DATA](state, payload) {
    Vue.set(state.salesExchangeData, 'data', payload.data)
  },
  [SET_TAX_INVOICE_LISTING](state, payload) {
    Vue.set(state.salesInvoiceListing, 'list', payload.list)
  },
  [SET_EPP_MOTO_APPROVAL_RESPONSE_DATA](state, payload) {
    Object.keys(payload).forEach(function(key) {
      Vue.set(state.eppMotoApprovalResponse, 'data', payload)
    })
  },
  [SET_EPP_MOTO_REJECTION_RESPONSE_DATA](state, payload) {
    Object.keys(payload).forEach(function(key) {
      Vue.set(state.eppMotoRejectionResponse, 'data', payload)
    })
  },
  [SET_BACK_OFFICE_ENROLLMENT_TYPE](state, payload) {
    Vue.set(state.enrollmentTypeList, 'list', payload)
  },
  [SET_CART_ADDITIONAL_ATTRIBUTES_INCOMPLETE_IDS](state, payload) {
    let availableIndex = state.cartAdditionalAttributesInCompleteIds[payload.key].findIndex(x => x === payload.id)
    if (availableIndex === -1) {
      state.cartAdditionalAttributesInCompleteIds[payload.key].push(payload.id)
    }
  },
  [UNSET_CART_ADDITIONAL_ATTRIBUTES_INCOMPLETE_IDS](state, payload) {
    if (payload !== undefined && payload.key !== undefined && payload.id !== undefined) {
      let removeIndex = state.cartAdditionalAttributesInCompleteIds[payload.key].findIndex(x => x === payload.id)
      if (removeIndex !== -1) {
        state.cartAdditionalAttributesInCompleteIds[payload.key].splice(removeIndex, 1)
      }
    } else {
      state.cartAdditionalAttributesInCompleteIds['product_ids'].splice(
        0,
        state.cartAdditionalAttributesInCompleteIds['product_ids'].length
      )
      state.cartAdditionalAttributesInCompleteIds['kitting_ids'].splice(
        0,
        state.cartAdditionalAttributesInCompleteIds['kitting_ids'].length
      )
    }
  },
  [SET_BACK_OFFICE_ENROLLMENT_RANK](state, payload) {
    Vue.set(state.enrollmentSalesRankList, 'list', payload.data)
  },
  [UNSET_SALES_PRODUCTS_LIST_DATA](state) {
    Vue.set(state.salesProductSearchList, 'list', [])
  },
  [SET_SALE_ELIGIBLE_ERROR](state, payload) {
    Vue.set(state.saleEligibleApiHasError, 'error', payload)
  },
  [SET_SALE_ELIGIBLE_TRANSFER_SEARCH](state, payload) {
    Vue.set(state.eligibleSaleForTransfer, 'list', payload.list)
  },
  [SET_SALE_TRANSFER_DATA](state, payload) {
    Vue.set(state.saleTransferData, 'data', payload)
  },
  [UNSET_SALE_TRANSFER_DATA](state, payload) {
    Vue.set(state.saleTransferData, 'data', [])
  },
  [SET_SALE_SV_TRANSFER_BY_PRODUCT_ITEMS](state, payload) {
    Vue.set(state.saleSvTransfer, 'itemsInfo', payload)
  },
  [SET_SV_TRANSFER_BY_PRODUCT_FORM_DATA](state, payload) {
    Vue.set(state.saleSvTransfer, 'data', payload)
  },
  [UNSET_SV_TRANSFER_BY_PRODUCT_DATA](state) {
    state.saleSvTransfer = {
      itemsInfo: {},
      data: {},
    }
  },
}
